import React from "react";
import { Battery, LayoutGrid, Sparkles, Zap } from "lucide-react";

// Slug dell'URL del listino: "Spartano" -> "spartano"
export const planSlug = (plan) =>
  String(plan.name || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const ACCENT_THEME = {
  green: {
    stripe: "bg-gradient-to-b from-[#0FB36B] to-[#12c777]",
    tagText: "text-[#0FB36B]",
    cta: "bg-[#0A1F44] hover:bg-[#0d2855] text-white",
    badge: "hidden",
    border: "border-gray-200",
    ring: "",
  },
  yellow: {
    stripe: "bg-gradient-to-b from-[#F4C542] to-[#e6b838]",
    tagText: "text-[#b48411]",
    cta: "bg-[#F4C542] hover:bg-[#e6b838] text-[#0A1F44]",
    badge: "bg-[#F4C542] text-[#0A1F44]",
    border: "border-[#F4C542] border-2",
    ring: "shadow-[0_30px_60px_-30px_rgba(244,197,66,0.4)]",
  },
  emerald: {
    stripe: "bg-gradient-to-b from-[#0f6b4a] to-[#14855c]",
    tagText: "text-[#0f6b4a]",
    cta: "bg-[#0f6b4a] hover:bg-[#0c5a3e] text-white",
    badge: "bg-[#0f6b4a] text-white",
    border: "border-gray-200",
    ring: "",
  },
  navy: {
    stripe: "bg-gradient-to-b from-[#0A1F44] to-[#122d63]",
    tagText: "text-[#0A1F44]",
    cta:
      "bg-gradient-to-r from-[#0A1F44] to-[#122d63] hover:from-[#0d2855] hover:to-[#173584] text-white",
    badge: "bg-[#0A1F44] text-white",
    border: "border-gray-200",
    ring: "",
  },
};

const ROLE_ICON = {
  Moduli: LayoutGrid,
  Inverter: Zap,
  Accumulo: Battery,
};

export const roleIcon = (role) => ROLE_ICON[role] || LayoutGrid;

// Blocco "su richiesta" (listino Elite)
export const OnRequestBox = ({ onRequest }) => (
  <div className="flex flex-col items-center justify-center text-center bg-gradient-to-br from-[#0A1F44]/[0.03] to-[#F4C542]/[0.06] border border-dashed border-[#0A1F44]/20 rounded-2xl px-6 py-12 min-h-[280px]">
    <span className="inline-flex w-14 h-14 items-center justify-center rounded-full bg-[#F4C542] text-[#0A1F44] mb-3">
      <Sparkles className="w-6 h-6" />
    </span>
    <h4 className="text-xl font-montserrat font-extrabold text-[#0A1F44] mb-1.5">
      {onRequest.title}
    </h4>
    <p className="text-[14px] text-gray-600 max-w-md leading-relaxed">
      {onRequest.description}
    </p>
  </div>
);
